import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  modal: {
    padding: '3rem 2.4rem 0',
    maxWidth: '80%',
    maxHeight: '85vh',
    marginTop: '6.5rem',
    position: 'relative',
    '& > div:last-child': {
      width: '80%',
      margin: '0 auto',
    },
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'center',
    position: 'sticky',
    bottom: 0,
    left: 0,
    right: 0,
    background: colors.neutral.white,
    padding: '3rem 0',
    borderTop: `0.1rem solid ${colors.neutral[300]}`,

    '& button': {
      margin: '0 auto',
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
